var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#E2F7F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E2F7F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5C8.13438 5.5 5 8.63438 5 12.5C5 16.3656 8.13438 19.5 12 19.5C15.8656 19.5 19 16.3656 19 12.5C19 8.63438 15.8656 5.5 12 5.5ZM12.3484 15.8938L12.3516 16.3891C12.3516 16.4578 12.2953 16.5156 12.2266 16.5156H11.7828C11.7141 16.5156 11.6578 16.4594 11.6578 16.3906V15.9C10.2703 15.7969 9.61719 15.0063 9.54688 14.1469C9.54063 14.0734 9.59844 14.0109 9.67188 14.0109H10.3938C10.4547 14.0109 10.5078 14.0547 10.5172 14.1141C10.5969 14.6094 10.9828 14.9797 11.675 15.0719V12.8422L11.2891 12.7438C10.4719 12.5484 9.69375 12.0391 9.69375 10.9828C9.69375 9.84375 10.5594 9.23125 11.6656 9.12344V8.60781C11.6656 8.53906 11.7219 8.48281 11.7906 8.48281H12.2297C12.2984 8.48281 12.3547 8.53906 12.3547 8.60781V9.11875C13.425 9.22656 14.2281 9.85156 14.3219 10.825C14.3297 10.8984 14.2719 10.9625 14.1969 10.9625H13.4953C13.4328 10.9625 13.3797 10.9156 13.3719 10.8547C13.3094 10.3984 12.9438 10.0266 12.3484 9.94531V12.0438L12.7453 12.1359C13.7578 12.3859 14.4469 12.8703 14.4469 13.9547C14.4469 15.1313 13.5719 15.7875 12.3484 15.8938ZM10.6656 10.9109C10.6656 11.3078 10.9109 11.6156 11.4391 11.8063C11.5125 11.8359 11.5859 11.8594 11.6734 11.8844V9.94688C11.0969 10.0203 10.6656 10.3438 10.6656 10.9109ZM12.4859 13.0234C12.4422 13.0141 12.3984 13.0031 12.3484 12.9891V15.0781C13.0141 15.0188 13.4734 14.6531 13.4734 14.0406C13.4734 13.5609 13.225 13.2484 12.4859 13.0234Z",
    fill: "#6DD8CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.8597925d546800750af635e618d5d904.svg";
export { ForwardRef as ReactComponent };